module.exports = "fragment VerifyPhoneNumberFailureFragment on VerifyPhoneNumberFailure {\n  failureType\n  failureMessage\n}\n"